import Vue from "vue";
import Vuex from "vuex";

import User from "./modules/UserVuex.js";
import App from "./modules/AppVuex.js";
import Notification from "./modules/NotificationVuex.js";
import DateFilter from './modules/DateFilterVuex'

import Driver from "@/_backoffice/_financial/store/modules/DriverVuex.js";



import Stock from "./modules/StockVuex.js";
import RefillStock from "./modules/RefillStockVuex.js";

import Status from './modules/StatusVuex'

import FinancialStore from "@/_backoffice/_financial/store/index.js"
import RegistrationsStore from "@/_backoffice/_registrations/store/index.js"
import WholesaleStore from "@/_wholesale_order/store/index.js"

import  ClientOrderStore from "@/_backoffice/_client_order/store/index.js"

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    User,
    App,
    Notification,
    DateFilter,
    Driver,
    Stock,
    RefillStock,
    Status,
    ...FinancialStore,
    ...RegistrationsStore,
    ...WholesaleStore,
    ...ClientOrderStore
  }
});

export default store;
